import styled from "styled-components";

export const EquipmentTemplate = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  gap: 16px;
`;

export const EquipmentTopbar = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

export const EquipmentShipTitle = styled.h3`
  font-size: 1.8rem;
  font-weight: 600;
  line-height: 32px;
`;

export const EquipmentTabBox = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  border-bottom: 1px solid ${(props) => props.theme.colors.black8};
  justify-content: space-between;
`;
